<template>
  <td
    v-if="isVisible"
    :class="[
      `${position}-row-controls`,
      (panel.isFixed) ? `is-fixed ${(position === 'left') ? 'right' : 'left'}-fixed-shadow` : '',
      panel.classes
    ]"
    :style="[{transform: `${(panel.isFixed) ? `translateX(${x}px)` : ''}`}, panel.styles]"
    class="row-controls">
    <ul>
      <li
        v-for="control in listControls"
        :key="control.type"
        :class="[`control-${control.type}`, control.classes]">
        <column-controls-button
          :type="control.type"
          :row="row"
          :template="control.template"
          :title="title"
          :controlTitle="control.title"
          :buttonClass="control.buttonClass"
          :disabledExpression="control.disabled"
          @onClick="handleButton(control)"
        >
        </column-controls-button>
      </li>
      <slot />
    </ul>
  </td>
</template>

<script>
import ColumnControlsButton from './Button'
export default {
  name: 'GridColumnControls',
  components: {
    ColumnControlsButton
  },
  props: {
    row: { type: Object, required: true },
    panel: { type: Object, required: true },
    isPreviewMode: { type: Boolean, required: true },
    x: { default: 0 },
    position: { type: String, default: 'left' },
    title: { type: String, default: '' }
  },
  computed: {
    isVisible () {
      return this.panel.controls.length && !this.isPreviewMode
    },
    listControls () {
      return this.panel.controls.filter((control) => {
        let { isVisible } = control
        let result = this.checkEs6AndRun(isVisible, this.row)
        return !([false, 'false'].some((value) => result === value))
      })
    }
  },
  methods: {
    handleButton (control) {
      this.$emit('handleButton', control)
    }
  }
}
</script>
<style lang="stylus">
.row-controls {
  padding .7rem
  width 5%

  ul {
    list-style none
    margin 0
    padding 0
    white-space nowrap
    display flex
    flex-wrap wrap
    > li {
      padding .1rem .2rem
      margin 0
      display inline-block

      > button {
        line-height 2.2rem
        position relative
        overflow hidden

        .helper-disable:before {
          content ''
          position absolute
          top 0
          left 0
          width 100%
          height 100%
          background rgba(255, 255, 255, .3)
        }
      }
    }
  }

  .icon-db {
    margin 0 .5rem 0 0
    opacity .4
    transition opacity .22s ease-in-out
  }

  button:hover,
  button:focus {
    .icon-db {
      opacity 1
    }
  }
  .control-edit,
  .control-pdf,
  .control-delete,
  .control-custom,
  .control-details {
    button {
      line-height 1.2
      padding .4rem .6rem
      font-size: 1.2rem
      font-weight bold
      background none
      color #09729b
      box-shadow none
      &:hover {
        background #04ace7
        color #fff
        box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.2)
      }
      i {
        display none
      }
    }
  }
  .control-delete{
    button {
      color #ef8176
      &:hover {
        background #ef8176
        color #fff
      }
    }
  }
  // CSS USER STYLES
  &.controls-inline{
    > ul {
      flex-wrap nowrap
    }
  }
}
</style>
